export default function(){
  console.warn('addMenus方法已经被弃用，请及时删除相关引用代码。');
}
// export default (store, set) => data => {
//   if (!(data instanceof Array))
//     return console.warn('$addMenus参数不是个数组，将被忽略。')
//   store.commit(
//     'main/menus/setModuleMenus',
//     reform(data, store.state.main.user.permissionTags)
//   )
//   function reform(data, permissionTags) {
//     return data.filter(item => {
//       // 未配置meta不转为菜单
//       if (!item.meta) {
//         console.warn('菜单对象未配置meta属性，无法正常生成菜单，已丢弃！')
//         return false
//       }
//       // 配置了NonMenu 不转为菜单
//       if (item.meta.NonMenu) return false

//       // 配置了permissionTag但未匹配到permissionTag的不转为菜单
//       let permissionTag = permissionTags.find(
//         _item => _item === item.meta.permissionTag
//       )
//       if (item.meta.permissionTag && !permissionTag) return false

//       // 添加用于激活操作的属性actived，默认为false
//       set(item.meta, 'actived', false)
//       if (item.type === 'custom') return true
//       // 如果成员有子成员则子成员也进行过滤
//       if (item.children && item.children.length > 0) {
//         item.children = reform(item.children, permissionTags)
//       }
//       return true
//     })
//   }
// }
